import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateExpense, useUploadReceipt } from '../../../hooks/useExpenses';
import { useToast } from '../../../hooks/useToast';
import ExpenseForm from '../../../components/forms/ExpenseForm';
import { ArrowLeft } from 'lucide-react';

const ExpenseCreate = () => {
  const navigate = useNavigate();
  const createExpense = useCreateExpense();
  const uploadReceipt = useUploadReceipt();
  const toast = useToast();

  const handleSubmit = async (data) => {
    try {
      const { receiptFile, ...expenseData } = data;
      const created = await createExpense.mutateAsync(expenseData);

      if (receiptFile) {
        try {
          await uploadReceipt.mutateAsync({ id: created.id, file: receiptFile });
        } catch (uploadError) {
          toast.warning('Despesa criada, mas erro ao enviar comprovante: ' + uploadError.message);
          navigate('/admin/despesas');
          return;
        }
      }

      toast.success('Despesa criada com sucesso!');
      navigate('/admin/despesas');
    } catch (error) {
      toast.error('Erro ao criar despesa: ' + error.message);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={() => navigate('/admin/despesas')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar para lista
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Nova Despesa</h1>
        <p className="text-gray-600 mt-1">
          Registre uma nova despesa no sistema
        </p>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <ExpenseForm onSubmit={handleSubmit} isLoading={createExpense.isPending || uploadReceipt.isPending} />
      </div>
    </div>
  );
};

export default ExpenseCreate;
